
import { Injectable } from '@angular/core';

//import { MessageService } from 'src/app/core/services/message.service';
//import { PageDonnee } from 'src/app/shared/interfaces/page-donnee';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {

  constructor() { }

  enumVersOptions<T extends { [cle: string]: string | number }>(
    enumObj: T
  ): { value: string; label: string }[] {
    return Object.entries(enumObj).map(([cle, valeur]) => ({
      value: cle,
      label: String(valeur)
    }));
  }

  obtenirLibelleDepuisCleEnum<T extends Record<string, string | number>>(
    enumObj: T,
    cleEnum: keyof T
  ): string {
    return enumObj[cleEnum]
      ? this.formaterLibelle(String(enumObj[cleEnum]))
      : 'Inconnu';
  }
  

  public formaterLibelle(valeur: string): string {
    return valeur
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }

}
